export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';
export const SUBSCRIBE_USER_FAVOURITES = 'SUBSCRIBE_USER_FAVOURITES';
export const UPDATE_USER_FAVOURITES = 'UPDATE_USER_FAVOURITES';
export const CLEAR_USER_FAVOURITES = 'CLEAR_USER_FAVOURITES';


// WEBPACK FOOTER //
// ./src/actions/types.js